import React from 'react'
import Layout from '../Layout/Layout'
import {CourseD} from '../components/coursedetail/CourseMainP'

export default function courses() {
    return (
        <div>
         <Layout>
         <CourseD />
        </Layout>
        </div>
    )
}
